import React from "react";
import {FormatCurrencyWithoutSymbol} from "../../../../Services/Utils";

export const tableColumns = [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (_, tableMeta) => {
                const {page, rowsPerPage} = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                return <>{rowNumber}</>;
            },
            sort: false,
        },
    },
    {
        name: "noFakturJual",
        label: "Nomor Faktur Jual",
    },
    {
        name: "tanggalFakturJual",
        label: "Tanggal Faktur Jual",
    },
    {
        name: "noPO",
        label: "No. PO",
    },
    {
        name: "nomorBuku",
        label: "No. Buku",
    },
    {
        name: "dataLeasing.leasingName",
        label: "Nama Leasing",
    },
    {
        name: "namaPembeli",
        label: "Nama Pembeli",
    },
    {
        name: "namaSTNK",
        label: "Nama STNK",
    },
    {
        name: "dataVariant.kodeVariant",
        label: "Kode Varian",
    },
    {
        name: "dataVariant.namaVariant",
        label: "Nama Varian",
    },
    {
        name: "dataWarna.kodeWarna",
        label: "Kode Warna",
    },
    {
        name: "dataWarna.namaWarnaPabrik",
        label: "Nama Warna",
    },
];

export const nameOptions = [
    {
        value: "STNK",
        label: "Nama STNK",
    },
    {
        value: "Pembeli",
        label: "Nama Pembeli",
    },
];

export const listBbmColumns = [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (_, tableMeta) => {
                const {page, rowsPerPage} = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                return <>{rowNumber}</>;
            },
            sort: false,
        },
    },
    {name: "nomorBBM", label: "No BBM", options: {sort: false}},
    {name: "tanggalBBM", label: "Tanggal BBM", options: {sort: false}},
    {name: "keterangan", label: "Keterangan", options: {sort: false}},
    {
        name: "totalAmount",
        label: "Total (Rp)",
        options: {sort: false, customBodyRender: val => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "sisaAmount",
        label: "Sisa (Rp)",
        options: {sort: false, customBodyRender: val => FormatCurrencyWithoutSymbol({number: val})}
    },
];

export const TabLabels = {
    BELUM_PENAGIHAN: "Belum Penagihan",
    SUDAH_PENAGIHAN: "Sudah Penagihan",
    PELUNASAN: "Pelunasan",
};

export const leasingPaymentStatus = {
    BELUM_PENAGIHAN: "BELUM_PENAGIHAN",
    SUDAH_PENAGIHAN: "SUDAH_PENAGIHAN",
    PELUNASAN: "PELUNASAN",
    BATAL: "BATAL"
}

export const PelunasanStatus = {
    BELUM_DIBAYAR: "BELUM_DIBAYAR",
    INCOMPLETE: "INCOMPLETE",
    LUNAS: "LUNAS",
};

export const JenisCetakanOptions = [
  {
    label: "Laporan Belum Penagihan",
    value: "LAPORAN_BELUM_PENAGIHAN",
  },
  {
    label: "Laporan Sudah Penagihan",
    value: "LAPORAN_SUDAH_PENAGIHAN",
  },
  {
    label: "Laporan Alokasi BBM",
    value: "LAPORAN_ALOKASI_BBM",
  },
];

export const PelunasanStatusOptions = [
  {
    label: "BELUM DIBAYAR",
    value: "BELUM_DIBAYAR",
  },
  {
    label: "INCOMPLETE",
    value: "INCOMPLETE",
  },
  {
    label: "LUNAS",
    value: "LUNAS",
  },
];